module.exports = __webpack_public_path__ + "media/images/icons/country_flags/by-9450056930b0536448e781d0f1ea566f.svg";